import { useMemo } from "react";
import useTasks from "./use-tasks";

export default function useTask(id: string) {

    const {tasks, isLoading} = useTasks();

    const task = useMemo(() => {
        return tasks.find(t => t.id === id);
    }, [tasks, id])

    return {
        task,
        isLoading
    }
}
